import { createStyles, darken, Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        searchBox: {
            // alignItems: "center",
            display: "flex",
            flexFlow: "row nowrap",
            justifyContent: "space-between",
            marginBottom: theme.spacing(1),
        },
        textField: {
            "& input": {
                fontSize: ".8rem",
            },
            "& textarea": {
                fontSize: ".8rem",
            },
            "& .MuiFormLabel-root": {
                color: theme.palette.primary.main,
            },
            "& .MuiSelect-outlined.MuiSelect-outlined": {
                padding: "13px 14px",
                fontSize: ".8rem",
            },
            "& .MuiOutlinedInput-multiline": {
                padding: "10px 14px",
            },
        },
        searchField: {
            width: "100%",
        },
        leadsGrid: {
            width: "100%",
        },
        leadsGridLi: {
            width: "100%",
        },
        addBtn: {
            marginTop: theme.spacing(0.9),
            padding: theme.spacing(1.3),
        }
    })
);

export default useStyles;
